import { ComponentRef, EnvironmentInjector, Injectable, createComponent, inject } from '@angular/core';
import { Validators } from '@angular/forms';

import { filter, map } from 'rxjs';

import { InputChoices } from '@camelot/form-model';
import { fullName, isNonNullable } from '@camelot/utils';

import { InputChoiceTemplateComponent } from '../../components/user-input-template/user-input-template.component';
import { CamUsersService } from '../users.service';

export enum EUserFormFields {
  user = 'user',
}

type ParamsFields = {
  label?: string;
};
@Injectable({
  providedIn: 'root',
})
export class CamUserInputService {
  private _usersService = inject(CamUsersService);
  private environmentInjector = inject(EnvironmentInjector);

  private _compRef: ComponentRef<InputChoiceTemplateComponent> | null = null;

  public getUserInput(value?: string, params?: ParamsFields) {
    const compRef = this._createOrUsed();

    return new InputChoices({
      key: EUserFormFields.user,
      label: params?.label,
      multiple: false,
      withSearch: true,
      options: this._usersService.fetchUsers$().pipe(
        filter(isNonNullable),
        map(users =>
          users.map(user => ({
            id: user.id,
            name: fullName({ firstName: user.firstName, name: user.lastName }),
            data: user,
          }))
        )
      ),
      value: value ? [value] : [],
      choiceTemplate: { one: compRef.instance.getTemplate() },
      validators: [Validators.required],
    });
  }

  private _createOrUsed() {
    const hostElement = document.createElement('div');
    document.body.appendChild(hostElement);
    this._compRef = createComponent(InputChoiceTemplateComponent, {
      hostElement: hostElement,
      environmentInjector: this.environmentInjector,
    });

    return this._compRef!;
  }
}
